import m from "./ghl-ui.es1589.js";
import d from "./ghl-ui.es1590.js";
import n from "./ghl-ui.es1586.js";
import u from "./ghl-ui.es1587.js";
import c from "./ghl-ui.es1588.js";
import s from "./ghl-ui.es1591.js";
import { Parser as p } from "./ghl-ui.es1670.js";
import { dayPeriodEnumToHours as l } from "./ghl-ui.es1671.js";
var _ = /* @__PURE__ */ function(f) {
  u(e, f);
  var i = c(e);
  function e() {
    var a;
    m(this, e);
    for (var t = arguments.length, o = new Array(t), r = 0; r < t; r++)
      o[r] = arguments[r];
    return a = i.call.apply(i, [this].concat(o)), s(n(a), "priority", 80), s(n(a), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a;
  }
  return d(e, [{
    key: "parse",
    value: function(t, o, r) {
      switch (o) {
        case "a":
        case "aa":
        case "aaa":
          return r.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return r.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return r.dayPeriod(t, {
            width: "wide",
            context: "formatting"
          }) || r.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(t, o, r) {
      return t.setUTCHours(l(r), 0, 0, 0), t;
    }
  }]), e;
}(p);
export {
  _ as AMPMParser
};
